import AppNavbar from './AppNavbar';
import Footer from './Footer';
import TopographicBackground from './background/TopographicBackground';
import { Outlet } from 'react-router-dom';

function Layout() {
  return (
    <div className="App">
      <TopographicBackground />
      <AppNavbar className="sticky-navbar" />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default Layout;